import { Typography } from "antd";
import React, { useState } from "react";

const SMHIWarning = ({
  isMobile,
  headline,
  event,
  desc,
  severity,
  color,
  time, callback, settings
}) => {
  const [btnState, setBtnState] = useState(false);

  const divStyle = {
    borderBottom: "2px solid",
    borderColor: color,
    margin: "20px",
  };

  const NewDataHour = settings.newDataHour;
  const dateObj = new Date(time);
  const timeDiffMillis = Date.now() - dateObj.getTime();
  const timeDiffHours = timeDiffMillis / 1000 / 60 / 60;
  if (timeDiffHours > NewDataHour) {
    callback(false);
  } else {
    callback(true);
  }

  if(headline === '')
    headline = 'No headline'

  return (
    <>
      {isMobile === "true" ? (
        <div style={divStyle}>
          <Typography.Title level={5} onClick={() => setBtnState(!btnState)} className="tileHeader">
            {headline}
          </Typography.Title>
          <p className="tileP">{event}</p>
          {btnState && (
            <>
              <p className="tileP">{severity}</p>
              <p
                className="tileP"
                dangerouslySetInnerHTML={{
                  __html: desc
                    .replace("Var:", "<br/>Var:")
                    .replace("Intensitet:", "<br/>Intensitet:")
                    .replace("Kommentar:", "<br/>Kommentar:")
                    .replace("Kommentar: -", ""),
                }}
              />
            </>
          )}
        </div>
      ) : (
        <div style={divStyle}>
          <Typography.Title level={5} onClick={() => setBtnState(!btnState)} className="tileHeader">
            {headline}
          </Typography.Title>
          <p className="tileP">{event}</p>
          <p className="tileP">{severity}</p>
          <p
            className="tileP"
            dangerouslySetInnerHTML={{
              __html: desc
                .replace("Var:", "<br/>Var:")
                .replace("Intensitet:", "<br/>Intensitet:")
                .replace("Kommentar:", "<br/>Kommentar:")
                .replace("Kommentar: -", ""),
            }}
          />
        </div>
      )}
    </>
  );
};

export default SMHIWarning;
